// Input masks and formatters for Brazilian fields

export const maskCNPJ = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

export const maskPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) {
    return d
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
  return d
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2");
};

// Format BRL: input is a string with digits only; returns "R$ 1.234,56"
export const formatBRL = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const num = typeof v === "number" ? v : Number(v);
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatNumber = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const num = typeof v === "number" ? v : Number(v);
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("pt-BR");
};

// Currency input handler: keeps only digits, stores as cents/100 (float)
export const parseCurrencyInput = (rawTyped) => {
  const digits = onlyDigits(rawTyped);
  if (!digits) return { value: null, display: "" };
  const num = Number(digits) / 100;
  return { value: num, display: formatBRL(num) };
};

// Number input (integer/decimal) — comma decimal separator
export const parseNumberInput = (rawTyped) => {
  const cleaned = (rawTyped || "").replace(/[^\d,]/g, "").replace(",", ".");
  if (!cleaned) return { value: null, display: "" };
  const num = Number(cleaned);
  if (Number.isNaN(num)) return { value: null, display: rawTyped };
  return { value: num, display: rawTyped };
};
